module.exports = __webpack_public_path__ + "img/preview.616cee52.png";